import React from 'react';

import PageTitle from '../../common/PageTitle';
import MainBlock from './MainBlock';

import moment from 'moment';
import { useAutoTranslation } from '../../../helpers/useAutoTranslation';
// import AlertBlock from '../../common/AlertBlock';

const FinancePage = (props) => {
  const { history } = props;
  const { t } = useAutoTranslation();

  return (
    <>
      <PageTitle
        title={t('Финансы')}
        extraStr={`${t('Состояние на')} ${moment(new Date()).format('DD.MM.YYYY')}`}
      />

      <MainBlock history={history} />
    </>
  );
};

export default FinancePage;
